const toRibuahDesimal = (num: string) => {
    return Number(num)
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

export default toRibuahDesimal;
